import { render, staticRenderFns } from "./DocumentPrintItemCard.vue?vue&type=template&id=4e73c83e&scoped=true"
import script from "./DocumentPrintItemCard.vue?vue&type=script&lang=js"
export * from "./DocumentPrintItemCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintItemCard.vue?vue&type=style&index=0&id=4e73c83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e73c83e",
  null
  
)

export default component.exports